<!--
  首页跳转到这里
  mall/src/views/user-center/index/index.vue
  user-center-index
-->

<template>
  <div class="user-center-index-page">
    <div class="box1 flex-col row-center" :style="$user_index_bg_2()">
      <div class="box1-content flex-row col-center">
        <img :src="userInfo.avatar" class="user-head" />
        <div class="ml14">
          <div class="fs18">{{ userInfo.nickName }}</div>
        </div>
      </div>
    </div>
    <div class="box2 flex-col row-center">
      <div class="box2-content flex-row row-between">
        <div>
          <div style="color: #4a4a4a; font-size: 15px">我的卡券</div>
          <div
            class="mt8"
            style="color: #979797; font-size: 12px; text-align: center"
          >
            <span v-if="userInfo.bindCard > 0">{{ userInfo.bindCard }} 张</span>
            <span v-else>暂无卡券</span>
          </div>
        </div>
        <router-link
          style="margin-right: 4px; font-weight: bold; font-size: 16px"
          to="user-cards"
        >
          <img
            :src="`${publicPath}images/user-center/icon1.png`"
            alt="查看我的卡券"
            style="width: 40px; height: 40px"
          />
        </router-link>
      </div>
    </div>

    <!-- 用户中心 订单链接 -->
    <div class="box5 mt11">
      <div class="box5-content flex-col row-around">
        <div class="flex-row row-between">
          <div style="font-size: 15px; color: #4a4a4a">我的订单</div>
        </div>
        <div class="flex-row row-between" style="padding: 0 10px">
          <div
            class="item-box flex-col col-center"
            v-on:click="
              $router.push({ path: 'order-list', query: { tabIndex: '1' } })
            "
          >
            <div class="icon-box flex-row col-center row-center bgc1">
              <div class="iconfont icon-icon-8 icon-base"></div>
            </div>
            <div class="mt10">待付款</div>
          </div>
          <div
            class="item-box flex-col col-center"
            v-on:click="
              $router.push({ path: 'order-list', query: { tabIndex: '2' } })
            "
          >
            <div class="icon-box flex-row col-center row-center bgc1">
              <div class="iconfont icon-icon-9 icon-base"></div>
            </div>
            <div class="mt10">待发货</div>
          </div>
          <div
            class="item-box flex-col col-center"
            v-on:click="
              $router.push({ path: 'order-list', query: { tabIndex: '3' } })
            "
          >
            <div class="icon-box flex-row col-center row-center bgc1">
              <div class="iconfont icon-wuliuqiache icon-base"></div>
            </div>
            <div class="mt10">待收货</div>
          </div>
          <div
            class="item-box flex-col col-center"
            v-on:click="
              $router.push({ path: 'order-list', query: { tabIndex: '4' } })
            "
          >
            <div class="icon-box flex-row col-center row-center bgc1">
              <div class="iconfont icon-yiguanbi icon-base"></div>
            </div>
            <div class="mt10">已关闭</div>
          </div>
          <div
            class="item-box flex-col col-center"
            v-on:click="$router.push({ path: 'order-list' })"
          >
            <div class="icon-box flex-row col-center row-center bgc1">
              <div class="iconfont icon-dingdan icon-base"></div>
            </div>
            <div class="mt10 budo-213">全部订单</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box6 mt11">
      <div class="box6-content flex-col row-between" style="margin: 0">
        <div class="user-info flex-row row-between flex-wrap">
          <router-link to="user-center-help">
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div
                  class="iconfont icon-changjianwenti-mianxing icon-base"
                ></div>
              </div>
              <div>常见问题</div>
            </div>
          </router-link>
          <router-link
            :to="{ name: 'user-center-common', query: { type: 'service' } }"
          >
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div class="iconfont icon-icon-10 icon-base"></div>
              </div>
              <div>在线客服</div>
            </div>
          </router-link>

          <router-link to="user-center-address">
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div class="iconfont icon-dizhi icon-base"></div>
              </div>
              <div>地址管理</div>
            </div>
          </router-link>

          <router-link to="user-center-info">
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div class="iconfont icon-yijian icon-base"></div>
              </div>
              <div>身份信息</div>
            </div>
          </router-link>

          <router-link to="user-center-update-pwd">
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div class="iconfont icon-mimaffffffpx icon-base"></div>
              </div>
              <div>修改密码</div>
            </div>
          </router-link>

          <router-link
            :to="{ name: 'user-center-common', query: { type: 'about' } }"
          >
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div class="iconfont icon-guanyuwomen icon-base"></div>
              </div>
              <div>关于我们</div>
            </div>
          </router-link>

          <router-link
            :to="{ name: 'user-center-common', query: { type: 'agreement' } }"
          >
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div class="iconfont icon-yonghuxieyi icon-base"></div>
              </div>
              <div>用户协议</div>
            </div>
          </router-link>

          <router-link
            :to="{ name: 'user-center-common', query: { type: 'privacy' } }"
          >
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div
                  class="iconfont icon-show_yinsizhengce_fill icon-base"
                ></div>
              </div>
              <div>隐私政策</div>
            </div>
          </router-link>

          <router-link :to="{ name: 'bind-mobile' }">
            <div class="item-box flex-col col-center">
              <div class="icon-box">
                <div
                  class="iconfont icon-show_yinsizhengce_fill icon-base"
                ></div>
              </div>
              <div>绑定手机</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mall_wx_get_user_info } from "@/api/login";

import { $user_index_bg_2 } from "@/util/util";

export default {
  name: "index",

  data() {
    return {
      userInfo: {},

      tabActive: 0,
      publicPath: process.env.BASE_URL,
      moduleInfo: JSON.parse(sessionStorage.getItem("rc.module-info")),
    };
  },

  created() {
    budo_log.debug(
      "#318 created, $store.getters.userInfo=",
      this.$store.getters.userInfo,
      "window.history=",
      window.history
    );
  },

  methods: {
    $user_index_bg_2: $user_index_bg_2,

    forbidBack() {
      window.history.pushState("forward", null, "#");
      window.history.forward(1);
    },
  },

  mounted() {
    mall_wx_get_user_info().then((res) => {
      budo_log.debug("#246 mounted mall_wx_get_user_info", res);
      this.userInfo = res?.data || {};
    })
  },
};
</script>

<style lang="scss" scoped>
@import "index";

.user-info {
  a {
    width: 25%;
    padding-top: 10px;
  }

  .item-box {
    width: auto !important;
  }
}

.order-icon {
  font-size: 32px;
  color: #779af0;
}
</style>
